<template>
  <div>
    <!-- dialog -->
    <v-dialog
      v-model="dialog"
      max-width="500px"
      @click:outside="close"
      @keydown.esc="close"
    >
      <v-card>
        <v-progress-linear
          :active="isDialogVisible"
          :indeterminate="isDialogVisible"
          absolute
          top
          color="primary"
        ></v-progress-linear>
        <v-card-title>
          <span class="headline">{{ partner !== undefined && partner.id !== null ? "Modifier utilisateur" : "Nouvel administrateur" }}</span>
        </v-card-title>
        <v-alert
          v-model="isAlertVisible"
          color="error"
          text
          transition="slide-y-transition"
        >
          {{ message }}
        </v-alert>
        <v-form
          ref="form"
          @submit.prevent="submitForm"
        >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-select
                    v-model="partner.civility"
                    :items="selectOptions"
                    label="Civilité"
                    :rules="[rules.civility]"
                  ></v-select>
                </v-col>
                <v-col
                  cols="12"
                  sm="8"
                >
                  <v-text-field
                    v-model="partner.name"
                    label="Nom"
                    :rules="[rules.name]"
                  ></v-text-field>
                </v-col>

              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-text-field
                    v-model="partner.phone"
                    label="Téléphone"
                    type="text"
                    :rules="[rules.phone]"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="partner.email"
                    label="Email"
                    :rules="[rules.email]"
                  ></v-text-field>
                </v-col>
              </v-row>


              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-text-field
                    v-model="partner.promo_code"
                    label="Code Promo"
                    type="text"
                    :rules="[rules.promo_code]"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-text-field
                    v-model="partner.partner_percentage"
                    label="% Partenaire"
                    type="number"
                    :rules="[rules.partner_percentage]"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-text-field
                    v-model="partner.passenger_percentage"
                    label="% Passager"
                    type="number"
                    :rules="[rules.passenger_percentage]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-select
                    v-model="partner.lang"
                    :items="selectLang"
                    label="Langue"
                  ></v-select>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-select
                    v-model="partner.status"
                    :items="selectStatus"
                    label="Statut"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-text-field
                    v-model="partner.password"
                    :type="isPasswordVisible ? 'text' : 'password'"
                    label="Mot de passe"
                    placeholder="Mot de passe"
                    :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
                    hide-details="auto"
                    class="mb-2"
                    :rules="[rules.password_required]"
                    @click:append="isPasswordVisible = !isPasswordVisible"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                >
                  <v-text-field
                    v-model="partner.password_confirmation"
                    :type="isPasswordConfirmationVisible ? 'text' : 'password'"
                    label="Confirmer mot de passe"
                    :append-icon="isPasswordConfirmationVisible ? icons.mdiEyeOffOutline:icons.mdiEyeOutline"
                    :rules="[rules.password_confirmation_required]"
                    @click:append="isPasswordConfirmationVisible = !isPasswordConfirmationVisible"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              outlined
              @click="close"
            >
              Annuler
            </v-btn>
            <v-btn
              :disabled="isDialogVisible"
              :loading="isDialogVisible"
              color="success"
              type="submit"
            >
              {{ partner.id !== null ? "Modifier" : "Enregistrer" }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  getCurrentInstance, ref, watch, onMounted,
} from '@vue/composition-api'
import { mdiCalendar, mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { notify } from '@core/dynamicComponents/dynamicComponents'
import store from '@/store'

export default {
  name: 'PartnerFormDialog',
  emits: ['clickout', 'submitted'],

  props: {
    // eslint-disable-next-line vue/require-default-prop,vue/require-prop-type-constructor
    dialog: {
      type: Boolean,
      default: false,
    },
    // eslint-disable-next-line vue/require-default-prop
    partner: null,
  },

  setup(props) {
    const isPasswordVisible = ref(false)
    const isPasswordConfirmationVisible = ref(false)
    const date = ref(null)
    const menu = ref(false)
    const picker = ref(null)
    const menuref = ref(null)
    const form = ref(null)
    const message = ref('')
    const isDialogVisible = ref(false)
    const errors = ref('')
    const isAlertVisible = ref(false)
    const partnerForm = {
      id: null,
      name: null,
      email: null,
      phone: null,
      civility: null,
      password: null,
      password_confirmation: null,
      promo_code: null,
    }
    const rules = {
      password_required: true,
      password_confirmation_required: true,
      email: true,
      phone: true,
      lang: true,
      civility: true,
      name: true,
      role_id: true,
      promo_code: true,
    }

    const selectOptions = [
      { text: 'Monsieur', value: 'M.' },
      { text: 'Madame', value: 'Mme' },
   /*   { text: 'Sa Majesté', value: 'SM' },
      { text: 'Son Excellence', value: 'SE' },
      { text: 'Docteur', value: 'Dr' },
      { text: 'Professeur', value: 'Pr' },*/
    ]

    const selectStatus = [
      { text: 'Actif', value: 1 },
      { text: 'Inactif', value: 0 },
    ]

    const selectLang = [
      { text: 'Français', value: 'fr' },
      { text: 'English', value: 'en' },
    ]

    const instance = getCurrentInstance()

    watch(menu, val => {
      // eslint-disable-next-line no-return-assign,no-unused-expressions
      // val && setTimeout(() => (picker.value.activePicker = 'YEAR'))
    })

    const save = d => {
      menuref.value.save(d)
    }

    const close = () => {
      isAlertVisible.value = false
      message.value = ''
      rules.civility = true
      rules.name = true
      rules.lang = true
      rules.email = true
      rules.promo_code = true
      rules.password_confirmation_required = true
      rules.password_required = true
      rules.phone = true
      rules.role_id = true
      instance.emit('clickout')
    }

    const submitForm = () => {
      isAlertVisible.value = false
      isDialogVisible.value = true
      instance.emit('submitted')
      if (props.partner.id !== null) {
        store.dispatch('user/updatePartner', props.partner).then(response => {
          isDialogVisible.value = false
          notify(true, true, response.message)
          close()
        }).catch(error => {
          form.value.validate()
          message.value = error.response.data.message
          errors.value = error.response.data.errors
          if (error.response.data.errors !== undefined) {
            rules.password_required = error.response.data.errors.password !== undefined ? error.response.data.errors.password[0] : true
            rules.email = error.response.data.errors.email !== undefined ? error.response.data.errors.email[0] : true
            rules.name = error.response.data.errors.name !== undefined ? error.response.data.errors.name[0] : true
            rules.phone = error.response.data.errors.phone !== undefined ? error.response.data.errors.phone[0] : true
            rules.lang = error.response.data.errors.lang !== undefined ? error.response.data.errors.lang[0] : true
            rules.civility = error.response.data.errors.civility !== undefined ? error.response.data.errors.civility[0] : true
            rules.password_confirmation_required = error.response.data.errors.password_confirmation !== undefined ? error.response.data.errors.password_confirmation[0] : true
            rules.role_id = error.response.data.errors.role_id !== undefined ? error.response.data.errors.role_id[0] : true
            rules.promo_code = error.response.data.errors.promo_code !== undefined ? error.response.data.errors.promo_code[0] : true
          }
          isDialogVisible.value = false
          isAlertVisible.value = true
        })
      } else {
        store.dispatch('user/addPartner', props.partner).then(response => {
          isDialogVisible.value = false
          notify(true, true, response.message)
          close()
        }).catch(error => {
          form.value.validate()
          message.value = error.response.data.message
          errors.value = error.response.data.errors
          if (error.response.data.errors !== undefined) {
            rules.password_required = error.response.data.errors.password !== undefined ? error.response.data.errors.password[0] : true
            rules.email = error.response.data.errors.email !== undefined ? error.response.data.errors.email[0] : true
            rules.phone = error.response.data.errors.phone !== undefined ? error.response.data.errors.phone[0] : true
            rules.lang = error.response.data.errors.lang !== undefined ? error.response.data.errors.lang[0] : true
            rules.civility = error.response.data.errors.civility !== undefined ? error.response.data.errors.civility[0] : true
            rules.password_confirmation_required = error.response.data.errors.password_confirmation !== undefined ? error.response.data.errors.password_confirmation[0] : true
            rules.role_id = error.response.data.errors.role_id !== undefined ? error.response.data.errors.role_id[0] : true
            rules.promo_code = error.response.data.errors.promo_code !== undefined ? error.response.data.errors.promo_code[0] : true
          }
          isDialogVisible.value = false
          isAlertVisible.value = true
        })
      }
      instance.emit('submitted')
    }

    watch(() => props.partner.id, () => {
      /*store.dispatch('admin/hasMenuAccess', 'VIEWROLES').then(response => {
        if (response.result === true) {
          store.state.role.field.to_store = true
          store.state.role.field.paginate = 50
          store.dispatch('role/getRoleList', { page: 1, field: store.state.role.field }).catch(error => {
            console.log(error)
          })
        }
      })*/
    }, { deep: true })

    onMounted(() => {
      /*store.dispatch('partner/hasMenuAccess', 'VIEWROLES').then(response => {
        if (response === true) {
          store.state.role.field.to_store = true
          store.state.role.field.paginate = 50
          store.dispatch('role/getRoleList', { page: 1, field: store.state.role.field }).catch(error => {
            console.log(error)
          })
        }
      })*/
    })

    return {
      selectLang,
      selectStatus,
      selectOptions,
      isPasswordVisible,
      isPasswordConfirmationVisible,
      partnerForm,
      isAlertVisible,
      isDialogVisible,
      message,
      rules,
      submitForm,
      form,
      date,
      menu,
      picker,
      menuref,
      save,
      close,


      // icons
      icons: {
        mdiCalendar, mdiEyeOutline, mdiEyeOffOutline,
      },
    }
  },
}
</script>

<style scoped>

</style>
